import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_search_results extends PureComponent {
  render() {
    return (
      <div className="row" id="component_search_results">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Search Results</h2>
              <p>
                The search results component is the workhorse of the Nexoid
                eco-system. The results component displays a list of filtered
                results in a read only table. This component is incredibly
                powerful and is used for search, reports, and suggestions.
              </p>
              <InterfaceCompatibility
                dashboard={true}
                record={true}
                report={false}
                search={true}
              />
              <InterfaceProperties
                type={"search_results"}
                name={"select results"}
                searchGroup={true}
                padding={true}
                hide={true}
                order={true}
                tabIndex={true}
                sourceUrl={true}
                properties={[
                  {
                    property: "search_fuzziness",
                    description:
                      "How close a word needs to be trigger a match.",
                    defaults: '0 - 5 default "AUTO"',
                  },
                  {
                    property: "search_page_size",
                    description: "Number of search results displayed.",
                    defaults: "1 - 1000 default 25",
                  },
                  {
                    property: "search_default_phrase",
                    description:
                      "The default phrase the search results will search for.",
                    defaults: '"search phrase" default ""',
                  },
                  {
                    property: "search_phrase_fields",
                    description:
                      "Database fields that the search phrase will be tested against. You can increase the weighting of a particular field by adding a factor (^2 or ^3).",
                    defaults:
                      '["text_first_name", "text_last_name", "text_job_title^2"] default []',
                  },
                  {
                    property: "search_outputs",
                    description:
                      "Search output sets the database fields returned by a results request.",
                    defaults:
                      '["text_first_name", "text_last_name", "text_job_title", "long_age", "text_address"] default []',
                  },
                  {
                    property: "search_list_layout",
                    description:
                      "List layout defines the structure of the search resutls. See below for more details.",
                    defaults: "{ ... }",
                  },
                  {
                    property: "search_page_mode",
                    description:
                      'Allows you to set the presentation of the search results. The default is "pagination". ',
                    defaults:
                      '"pagination", "load more" default is "pagination"',
                  },
                  {
                    property: "search_show_stats",
                    description:
                      "Turns on or off the results total and API timings found under the search results.",
                    defaults: "true, false default is true",
                  },
                  {
                    property: "search_show_results_total",
                    description: "Show the total search results.",
                    defaults: "true, false default is true",
                  },

                  {
                    property: "record_watch",
                    description:
                      "Set a list of record data fields the search result component will watch. This will only work when the search results component is on a record view/edit pages. The search results component will refresh the results when one of the watch fields changes. This is useful for record_search_phrase and source_query_eval.",
                    defaults: '["text_name", "text_subject"] default is []',
                  },
                  {
                    property: "record_search_phrase ",
                    description:
                      "The record search phrase is a free text search phrase automatically generated from fields in your record. This will only work on record view/edit pages.",
                    defaults: '["text_name", "text_subject"] default is []',
                  },
                  {
                    property: "source_query_eval",
                    description:
                      "The source query eval allows you to convert a JSON string into an ElasticSearch query. This is useful for running automated queries with dynamic values. ",
                    defaults:
                      '"{ ... }",  "{ \\"term\\": { \\"text_status\\": \\"won\\" } }" default is ""',
                  },
                ]}
              />

              <h3>Structure "search_list_layout"</h3>

              <h3>Properties</h3>
              <p>
                The search_list_layout property defines how the search results
                will be displayed.
              </p>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">containers</td>
                    <td>
                      All result components; labels, icons etc are displayed in
                      containers. Containers define the order, row and row
                      width. An example container layout can be found below.
                      <br />
                      <i>{"{ ... } default is undefined"}</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">data_dynamic</td>
                    <td>
                      The data dynamic property tells the application to watch
                      for result updates This allows you to use on_change_eval
                      about scripts to Dynamically update search results.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">list_pad</td>
                    <td>
                      The list_pad property changes the padding of the master
                      list item container.
                      <br />
                      <i>true, false, 8, 16 default is false</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p>
                Below is a simple results layout structure. This structure has
                three rows. The first row has two containers, 25% and 75% wide.
                The second and third rows have containers that are both 100%
                wide. The third row has two components.
              </p>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td className="b top">Example</td>
                    <td className="b top">JSON</td>
                  </tr>
                  <tr>
                    <td className="b">search_list_layout</td>
                    <td className="darkCode darkbackground2">
                      <div>&#123;</div>
                      {/* <div className="i1">
                        <span className="jsonG">"selectable"</span>:{" "}
                        <span className="jsonP">false</span>,
                      </div> */}
                      <div className="i1">
                        <span className="jsonG">"data_dynamic"</span>:{" "}
                        <span className="jsonP">false</span>,
                      </div>
                      <div className="i1">
                        <span className="jsonG">"list_pad"</span>:{" "}
                        <span className="jsonP">false</span>,
                      </div>
                      <div className="i1">
                        <span className="jsonG">"containers"</span>: &#123;
                      </div>
                      <div className="i2">
                        <span className="jsonG">"top_left"</span>: &#123;
                      </div>
                      <div className="i3">
                        <span className="jsonG">"width"</span>:{" "}
                        <span className="jsonY">"fl25"</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"row"</span>:{" "}
                        <span className="jsonP">1</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">1</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"components"</span>: &#123;
                      </div>
                      <div className="i4">
                        <span className="jsonG">"id"</span>: &#123;
                      </div>
                      <div className="i5">
                        <span className="jsonG">"data_name"</span>:{" "}
                        <span className="jsonY">"id"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"display_bold"</span>:{" "}
                        <span className="jsonP">true</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">1</span>
                      </div>
                      <div className="i4">&#125;</div>
                      <div className="i3">&#125;</div>
                      <div className="i2">&#125;,</div>
                      <div className="i2">
                        <span className="jsonG">"top_right"</span>: &#123;
                      </div>
                      <div className="i3">
                        <span className="jsonG">"width"</span>:{" "}
                        <span className="jsonY">"fl75"</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"row"</span>:{" "}
                        <span className="jsonP">1</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">2</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"components"</span>: &#123;
                      </div>
                      <div className="i4">
                        <span className="jsonG">"text_name"</span>: &#123;
                      </div>
                      <div className="i5">
                        <span className="jsonG">"data_name"</span>:{" "}
                        <span className="jsonY">"text_name"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"display_bold"</span>:{" "}
                        <span className="jsonP">true</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">1</span>
                      </div>
                      <div className="i4">&#125;</div>
                      <div className="i3">&#125;</div>
                      <div className="i2">&#125;,</div>
                      <div className="i2">
                        <span className="jsonG">"middle"</span>: &#123;
                      </div>
                      <div className="i3">
                        <span className="jsonG">"width"</span>:{" "}
                        <span className="jsonY">"fl100"</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"row"</span>:{" "}
                        <span className="jsonP">2</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">1</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"components"</span>: &#123;
                      </div>
                      <div className="i4">
                        <span className="jsonG">"description"</span>: &#123;
                      </div>
                      <div className="i5">
                        <span className="jsonG">"data_name"</span>:{" "}
                        <span className="jsonY">"text_description"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"display_bold"</span>:{" "}
                        <span className="jsonP">false</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">2</span>
                      </div>
                      <div className="i4">&#125;</div>
                      <div className="i3">&#125;</div>
                      <div className="i2">&#125;,</div>
                      <div className="i2">
                        <span className="jsonG">"bottom"</span>: &#123;
                      </div>
                      <div className="i3">
                        <span className="jsonG">"width"</span>:{" "}
                        <span className="jsonY">"fl100"</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"row"</span>:{" "}
                        <span className="jsonP">3</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">1</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"components"</span>: &#123;
                      </div>
                      <div className="i4">
                        <span className="jsonG">"created_by_first_name"</span>:
                        &#123;
                      </div>
                      <div className="i5">
                        <span className="jsonG">"data_name"</span>:{" "}
                        <span className="jsonY">
                          "object_owner.text_first_name"
                        </span>
                        ,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"display_name"</span>:{" "}
                        <span className="jsonY">"Created by"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"icon"</span>:{" "}
                        <span className="jsonY">"person"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"icon_color"</span>:{" "}
                        <span className="jsonY">"#9E9E9E"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">1</span>
                      </div>
                      <div className="i4">&#125;,</div>
                      <div className="i4">
                        <span className="jsonG">"created_by_last_name"</span>:
                        &#123;
                      </div>
                      <div className="i5">
                        <span className="jsonG">"data_name"</span>:{" "}
                        <span className="jsonY">
                          "object_owner.text_last_name"
                        </span>
                        ,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">2</span>
                      </div>
                      <div className="i4">&#125;</div>
                      <div className="i3">&#125;</div>
                      <div className="i2">&#125;</div>
                      <div className="i1">&#125;</div>
                      <div>&#125;</div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3>Search List Layout Component</h3>
              <p>
                Unlike other types of components in the Nexoid ecosystem, there
                is only one search results list component. This component
                displays a single data field in the search results and supports
                modifiers like format, labels, icons, icon maps, bold, etc.
                Below is a list of properties the search results list component
                supports.
              </p>
              <h3>Properties</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">data_name</td>
                    <td>
                      <i
                        className="material-icons"
                        style={{
                          display: "inline-block",
                          height: 24,
                          position: "relative",
                          top: 6,
                          fontSize: 24,
                          color: "#F57C00",
                        }}
                      >
                        warning
                      </i>
                      Field in the database bound to this component. Use "id" to
                      bind the record ID.
                      <br />
                      <i>
                        "text_my_field" or "object_my_obj.text_my_field" or "id"
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">data_type</td>
                    <td>
                      The data type of the bound data. "date", "date_short" and
                      "date_long" will display the bound value as a local
                      datetime. "currency" and "number" will display bound value
                      as a number.
                      <br />
                      <i>
                        "currency", "date", "date_long", "date_short", "number"
                        default is ""
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">decimals</td>
                    <td>
                      Numbers including decimals are stored in the database as
                      whole numbers. This feature converts whole numbers to
                      decimals. A value of 0 will treat the value as a whole
                      number a value of 2 will divide number by 100 and show two
                      decimals. This will only work with data_type "number".
                      <br />
                      <i>0-8 default is 0</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">display_name</td>
                    <td>
                      The label name displayed to the left of the bound data.
                      <br />
                      <i>"Client", "Agent" default is ""</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">display_name_color</td>
                    <td>
                      Set the label color.
                      <br />
                      <i>"#D32F2F", "#1B5E20" default is "#757575"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">display_name_color_eval</td>
                    <td>
                      Change the color of the label using an eval function.
                      <br />
                      <i>
                        (event.value === 'John Smith' ? '#D32F2F' : undefined)
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">display_name_hide</td>
                    <td>
                      Hide the display name label bound data is null or
                      undefined.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">extra_padding</td>
                    <td>
                      Adds an extra 12px padding to the right of the label.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">hide</td>
                    <td>
                      Hides component from the interface.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">hide_if_eval</td>
                    <td>
                      Hides the component in the interface using a eval logic
                      for more information look up component eval in this
                      documentation.
                      <br />
                      <i>"(event.value !== 'John Smith')"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">icon</td>
                    <td>
                      The google material icon font text name that can be
                      selected from the icons section of this documentation.
                      <br />
                      <i>"home", "info_outline" default is "help_outline"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">icon_color</td>
                    <td>
                      The hex value of the icon color. Icon colors can be
                      selected from the marteiral design colours part of this
                      documention.
                      <br />
                      <i>"#F44336", "#4CAF50" default is "#9E9E9E"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">icon_color_eval</td>
                    <td>
                      Change the color of the icon using an eval function.
                      <br />
                      <i>
                        (event.item.record.text_name === 'John Smith' ?
                        '#D32F2F' : '#689F38')
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">icon_back_color_eval</td>
                    <td>
                      Change the background color of the icon using an eval
                      function.
                      <br />
                      <i>
                        (event.item.record.text_name === 'John Smith' ?
                        '#D32F2F' : '#689F38')
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">rtl</td>
                    <td>
                      Display components left to right.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">min_width</td>
                    <td>
                      Set the minimum width of the label.
                      <br />
                      <i>1 - 2000 default is undefined</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">order</td>
                    <td>
                      The left to right order that the labels will be displayed.
                      <br />
                      <i>1 - 10000 default is 1</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">value_bold</td>
                    <td>
                      Show the bound data in bold.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">value_brackets</td>
                    <td>
                      Show the bound data in brackets.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">value_color</td>
                    <td>
                      Set the value color.
                      <br />
                      <i>"#D32F2F", "#1B5E20" default is "#757575"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">value_color_eval</td>
                    <td>
                      Change the color of the value using an eval function.
                      <br />
                      <i>
                        (event.value === 'John Smith' ? '#D32F2F' : undefined)
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">value_id_prefix</td>
                    <td>
                      Manually set the ID prefix for data_name "id". You can use
                      this to remove the "-".
                      <br />
                      <i>"PRB-" default is record prefix in model</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">value_italics</td>
                    <td>
                      Show the bound data in italics.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">value_max_length</td>
                    <td>
                      Set the maximum length of a data string.
                      <br />
                      <i>1-4000 default is "auto"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">value_suffix</td>
                    <td>
                      Appended to the end of the value.
                      <br />
                      <i>"-", "/" default is ""</i>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3>Search Smart Values</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Value</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">[[ME_ID]]</td>
                    <td>The user ID of the current user session.</td>
                  </tr>
                  <tr>
                    <td className="b">[[RECORD_ID]]</td>
                    <td>
                      Record ID of the current record. This only works on the
                      edit record page.
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Search Results Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Search Results</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"search_results"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"search_group"</span>:{" "}
                  <span className="jsonY">"my_search_group"</span>,
                </div>

                <div className="i1">
                  <span className="jsonG">"search_output"</span>: [
                </div>
                <div className="i2">
                  <span className="jsonY">"text_subject"</span>
                </div>
                <div className="i1">],</div>

                <div className="i1">
                  <span className="jsonG">"source_sort"</span>: [
                </div>
                <div className="i2">
                  <span className="jsonY">"_score"</span>,
                </div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">
                    "object_created_by.date_created"
                  </span>
                  : &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonY">"desc"</span>
                </div>
                <div className="i3">&#125;</div>
                <div className="i2">&#125;</div>
                <div className="i1">],</div>
                <div className="i1">
                  <span className="jsonG">"search_list_layout"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"containers"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"top"</span>: &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"width"</span>:{" "}
                  <span className="jsonY">"fl100"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"row"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"components"</span>: &#123;
                </div>

                <div className="i5">
                  <span className="jsonG">"id"</span>: &#123;
                </div>
                <div className="i6">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"id"</span>,
                </div>
                <div className="i6">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>
                </div>
                <div className="i5">&#125;,</div>

                <div className="i5">
                  <span className="jsonG">"subject"</span>: &#123;
                </div>
                <div className="i6">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"text_subject"</span>,
                </div>
                <div className="i6">
                  <span className="jsonG">"value_bold"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i6">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">2</span>
                </div>
                <div className="i5">&#125;</div>
                <div className="i4">&#125;</div>
                <div className="i3">&#125;</div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_search_results;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_search_results.js